import Footer from "../components/Shared/Footer";
import { useState } from "react";
import OrderSummary from "../components/Order/OrderSummary";
import { getUserAddress, getUserDetails } from "../utils/auth";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Checkout = () => {
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(false);
    const userDetails = getUserDetails();
    // Since address is now nested inside userDetails
    const userAddress = userDetails?.address || {};
    
    const [paymentMethod, setPaymentMethod] = useState("cash");
    const [streetAddress, setStreetAddress] = useState(userAddress?.street_address || '');
    const [pincode, setPincode] = useState(userAddress?.pincode || '');
    const [state, setState] = useState('');
    const [shippingStateCode, setShippingStateCode] = useState('');


    // billing details
    const [billingFullName, setBillingFullName] = useState(userDetails ? `${userDetails.first_name} ${userDetails.last_name}` : '');
    const [billingEmail, setBillingEmail] = useState(userDetails?.email || '');
    const [billingMobile, setBillingMobile] = useState(userDetails?.mobile || '');
    const [billingGST, setBillingGST] = useState('');
    

    const [billingStreetAddress, setBillingStreetAddress] = useState(userAddress?.street_address || '');
    const [billingState, setBillingState] = useState(userAddress?.state || '');
    const [billingStateCode, setBillingStateCode] = useState('');
    const [billingPincode, setBillingPincode] = useState(userAddress?.pincode || '');

    const [fullname, setFullname] = useState(userDetails ? `${userDetails.first_name} ${userDetails.last_name}` : '');
    const [mobile, setMobile] = useState(userDetails?.mobile || '');
    const [email, setEmail] = useState(userDetails?.email || '');

    const stateMapping = {
        "JAMMU AND KASHMIR": "1",
        "HIMACHAL PRADESH": "2",
        "PUNJAB": "3",
        "CHANDIGARH": "4",
        "UTTARAKHAND": "5",
        "HARYANA": "6",
        "DELHI": "7",
        "RAJASTHAN": "8",
        "UTTAR PRADESH": "9",
        "BIHAR": "10",
        "SIKKIM": "11",
        "ARUNACHAL PRADESH": "12",
        "NAGALAND": "13",
        "MANIPUR": "14",
        "MIZORAM": "15",
        "TRIPURA": "16",
        "MEGHALAYA": "17",
        "ASSAM": "18",
        "WEST BENGAL": "19",
        "JHARKHAND": "20",
        "ORISSA": "21",
        "CHHATTISGARH": "22",
        "MADHYA PRADESH": "23",
        "GUJARAT": "24",
        "DADRA AND NAGAR HAVELI & DAMAN AND DIU": "26",
        "MAHARASHTRA": "27",
        "KARNATAKA": "29",
        "GOA": "30",
        "LAKSHADWEEP": "31",
        "KERALA": "32",
        "TAMIL NADU": "33",
        "PUDUCHERRY": "34",
        "ANDAMAN AND NICOBAR": "35",
        "TELANGANA": "36",
        "ANDHRA PRADESH": "37",
        "LADAKH": "38",
        "OTHER TERRITORY": "97",
        "OTHER COUNTRY": "99"
    };

    const handleOrderSuccess = () => {
        setIsProcessing(false);
        Swal.fire({
            icon: 'success',
            title: 'Order Placed Successfully!',
            text: 'You will receive an email confirmation shortly.',
            confirmButtonColor: '#75c043'
        }).then((result) => {
            if (result.isConfirmed) {
                navigate('/user/orders');
            }
        });
    };

    const handleOrderError = (error) => {
        setIsProcessing(false);
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error || 'Something went wrong! Please try again.',
            confirmButtonColor: '#75c043'
        });
    };

    return(
        <div>
            {isProcessing && (
                <div className="loading-overlay">
                    <div className="spinner-wrapper">
                        <div className="spinner-border text-success" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2">Processing your order...</p>
                    </div>
                </div>
            )}
            
            <style>
                {`
                    .loading-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(255, 255, 255, 0.8);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        z-index: 9999;
                    }
                    .spinner-wrapper {
                        text-align: center;
                    }
                    .spinner-border {
                        width: 3rem;
                        height: 3rem;
                        color: #75c043 !important;
                    }
                `}
            </style>

            <section className="breadcrumb-section pt-0">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb-contain">
                                <h2>Checkout</h2>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <a href="/"><i className="fa-solid fa-house"></i></a>
                                        </li>
                                        <li className="breadcrumb-item active">Checkout</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="checkout-section-2 section-b-space">
                <div className="container-fluid-lg">
                    <div className="row g-sm-4 g-3">
                        <div className="col-lg-8">
                            <div className="left-sidebar-checkout">
                                <div className="checkout-detail-box">
                                    <ul>
                                        <li>
                                            <div className="checkout-icon">
                                                <i className="fa-solid fa-location-dot" style={{color: 'var(--theme-color1)', fontSize: '30px', marginTop: '2px', marginLeft: '7px'}}></i>                  
                                            </div>
                                            <div className="checkout-box">
                                                <div className="checkout-title">
                                                    <h4>Delivery Address</h4>
                                                </div>
                                                <div className="checkout-detail">
                                                    <div className="row g-4">
                                                        <div className="col-xxl-12 col-lg-12 col-md-12">
                                                            <form className="row g-4">
                                                                <div className="col-6">
                                                                    <div className="form-floating theme-form-floating log-in-form">
                                                                        <input type="email" className="form-control" placeholder="Full Name" value={fullname} onChange={(e) => setFullname(e.target.value)} required/>
                                                                    </div>
                                                                </div>
                                                                <div className="col-6">
                                                                    <div className="form-floating theme-form-floating log-in-form">
                                                                        <input type="number" className="form-control" placeholder="Mobile No" value={mobile} onChange={(e) => setMobile(e.target.value)} required/>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12">
                                                                    <div className="form-floating theme-form-floating log-in-form">
                                                                        <input type="email" className="form-control" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required/>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12">
                                                                    <div className="form-floating theme-form-floating log-in-form">
                                                                        <input type="text" placeholder="Street Address" className="form-control" value={streetAddress} onChange={(e) => setStreetAddress(e.target.value)} required/>
                                                                    </div>
                                                                </div>

                                                                <div className="col-12">
                                                                <select 
                                                                            className="form-control" 
                                                                            value={state} 
                                                                            onChange={(e) => {
                                                                                setState(e.target.value);
                                                                                setShippingStateCode(stateMapping[e.target.value] || '');
                                                                            }}
                                                                            required
                                                                        >
                                                                            <option value="" disabled>Select State</option>
                                                                            {Object.keys(stateMapping).map((state) => (
                                                                                <option key={state} value={state}>{state}</option>
                                                                            ))}
                                                                            
                                                                        </select>
                                                                </div>
                                                                <div className="col-12">
                                                                    <div className="form-floating theme-form-floating log-in-form">
                                                                        <input type="number" className="form-control" placeholder="Pin Code" value={pincode} onChange={(e) => setPincode(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>




                                                {/* billing address */}
                                                 <div className="checkout-title" style={{marginTop: '20px'}}>
                                                    <h4>Billing Details</h4>
                                                </div>
                                                <div className="checkout-detail">
                                                    <div className="row g-4">
                                                        <div className="col-xxl-12 col-lg-12 col-md-12">
                                                            <form className="row g-4">
                                                            <div className="col-12">
                                                                    <div className="form-floating theme-form-floating log-in-form">
                                                                        <input type="text" placeholder="Full Name" className="form-control" value={billingFullName} onChange={(e) => setBillingFullName(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-12">
                                                                <div className="form-floating theme-form-floating log-in-form">
                                                                        <input type="text" placeholder="Email" className="form-control" value={billingEmail} onChange={(e) => setBillingEmail(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-12">
                                                                <div className="form-floating theme-form-floating log-in-form">
                                                                        <input type="text" placeholder="Mobile" className="form-control" value={billingMobile} onChange={(e) => setBillingMobile(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-12">
                                                                <div className="form-floating theme-form-floating log-in-form">
                                                                        <input type="text" placeholder="GST Number" className="form-control" value={billingGST} onChange={(e) => setBillingGST(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-12">
                                                                    <div className="form-floating theme-form-floating log-in-form">
                                                                        <input type="text" placeholder="Street Address" className="form-control" value={billingStreetAddress} onChange={(e) => setBillingStreetAddress(e.target.value)} />
                                                                    </div>
                                                                </div>

                                                                <div className="col-12">
                                                                    <div className="form-floating theme-form-floating log-in-form">
                                                                        <select 
                                                                            className="form-control" 
                                                                            value={billingState} 
                                                                            onChange={(e) => {
                                                                                setBillingState(e.target.value);
                                                                                setBillingStateCode(stateMapping[e.target.value] || '');
                                                                            }}
                                                                        >
                                                                            <option value="">Select State</option>
                                                                            {Object.keys(stateMapping).map((state) => (
                                                                                <option key={state} value={state}>{state}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12">
                                                                    <div className="form-floating theme-form-floating log-in-form">
                                                                        <input type="number" className="form-control" placeholder="Pin Code" value={billingPincode} onChange={(e) => setBillingPincode(e.target.value)} />
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>

                                       
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* <div className="col-lg-4">
                            <div className="right-side-summery-box">
                                <div className="summery-box-2">
                                    <div className="summery-header">
                                        <h3>Order Summary</h3>
                                    </div>
                                    <ul className="summery-contain">
                                        <li>
                                            <img src="../assets/images/vegetable/product/6.png" alt="Product" className="checkout-image" />
                                            <h4>Broccoli <span>X 2</span></h4>
                                            <h4 className="price">₹ 29.69</h4>
                                        </li>
                                    </ul>
                                    <ul className="summery-total">
                                        <li><h4>Total </h4><h4 className="price">₹ 19.28</h4></li>
                                    </ul>
                                </div>
                                <button className="btn text-white w-100 mt-4 fw-bold"
                                            style={{
                                                backgroundColor: "#3150A3",
                                                fontWeight: "bold",
                                            }}>Place Order</button>
                            </div>
                        </div> */}
                        
                        <OrderSummary 
                            fullname={fullname}
                            email={email}
                            mobile={mobile}
                            streetAddress={streetAddress}
                            state={state}
                            shipping_state_code={shippingStateCode}
                            pincode={pincode}
                            billing_streetAddress={billingStreetAddress}
                            billing_state={billingState}
                            billing_pincode={billingPincode}
                            billing_fullname={billingFullName}
                            billing_email={billingEmail}
                            billing_mobile={billingMobile}
                            billing_state_code={billingStateCode}
                            billing_gst={billingGST}
                            isProcessing={isProcessing}
                            setIsProcessing={setIsProcessing}
                            onOrderSuccess={handleOrderSuccess}
                            onOrderError={handleOrderError}
                        />
                    </div>
                    
                </div>
                
            </section>
            <Footer />
        </div>
    );
};

export default Checkout;